var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldHeartCareProtectionStreamlineFlex1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.65576 11.5715C1.65576 5.26145 4.24183 2.55713 5.10386 1.6557H18.8962C19.7583 2.55713 22.3443 5.26145 22.3443 11.5715C22.3443 18.783 15.5522 21.4429 12.1041 22.3443C8.65598 21.4429 1.65576 18.783 1.65576 11.5715Z",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 9.05329C9.66941 6.19353 7.20853 8.22551 7.17615 10.416C7.17615 13.6769 11.0779 16.3535 12.0001 16.3535C12.9224 16.3535 16.8241 13.6769 16.8241 10.416C16.7918 8.22551 14.3309 6.19353 12.0001 9.05329Z",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldHeartCareProtectionStreamlineFlex1);
export default __webpack_public_path__ + "static/media/Shield-Heart-Care-Protection--Streamline-Flex 1.003f8cb98bc5a822384f6e8da30c12ef.svg";
export { ForwardRef as ReactComponent };